import './dialogClose.scss'
import templateUrl from './dialogClose.html'

/**
 * Styled button on top right of screen in fullscreen dialog
 *
 * @example
 * <tmr-dialog-close on-close="$ctrl.$mdDialog.hide()"></tmr-dialog-close>
 *
 * @type {ngComponent}
 * @prop {function} onClose
 */
export const tmrDialogClose = {
  ngType: 'component',
  templateUrl,
  bindings: {
    onClose: '&',
  },
}
